"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var Option = antd_1.Select.Option;
var TabPane = antd_1.Tabs.TabPane;
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var ChannelField_1 = __importDefault(require("../Field/ChannelField/ChannelField"));
var _get = require('lodash/get');
var _cloneDeep = require('lodash/cloneDeep');
/**
 * RasterChannelEditor to map bands to rgb or grayscale
 */
var RasterChannelEditor = /** @class */ (function (_super) {
    __extends(RasterChannelEditor, _super);
    function RasterChannelEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelectionChange = function (rgbOrGray) {
            var onChange = _this.props.onChange;
            _this.setState({
                rgbOrGray: rgbOrGray
            }, function () {
                // reset channelSelection
                if (!rgbOrGray) {
                    onChange(undefined);
                }
            });
        };
        _this.getTabLabel = function (band) {
            var locale = _this.props.locale;
            var label = _get(locale, band + "BandLabel") ? _get(locale, band + "BandLabel") : band;
            return label;
        };
        /**
         * Checks if ChannelSelection is of type RGBChannel.
         */
        _this.isRgbChannel = function (channels) {
            return (channels.redChannel !== undefined
                || channels.greenChannel !== undefined
                || channels.blueChannel !== undefined);
        };
        /**
         * Checks if ChannelSelection is of type GrayChannel.
         */
        _this.isGrayChannel = function (channels) {
            return channels.grayChannel !== undefined;
        };
        /**
         * Updates ChannelField. Removes old props if channel type changes
         * from GrayChannel to RGBChannel or vice versa.
         */
        _this.onChannelFieldChange = function (name, channel) {
            var _a = _this.props, channelSelection = _a.channelSelection, onChange = _a.onChange;
            var newChannelSelection;
            if (!channelSelection
                || (_this.isGrayChannel(channelSelection) && name !== 'gray')
                || (_this.isRgbChannel(channelSelection) && name === 'gray')) {
                newChannelSelection = {};
                newChannelSelection[name + "Channel"] = channel;
            }
            else {
                newChannelSelection = _cloneDeep(channelSelection);
                newChannelSelection[name + "Channel"] = channel;
            }
            if (onChange) {
                onChange(newChannelSelection);
            }
        };
        _this.onTabChange = function (key) {
            var _a = _this.state, selectedTab = _a.selectedTab, restState = __rest(_a, ["selectedTab"]);
            _this.setState(__assign({ selectedTab: key }, restState));
        };
        var channelSelection = _get(props, 'channelSelection');
        var grayChannel = _get(props, 'channelSelection.grayChannel');
        _this.state = {
            rgbOrGray: !channelSelection ? 'rgb' : grayChannel ? 'gray' : 'rgb',
            selectedTab: !channelSelection ? 'red' : grayChannel ? 'gray' : 'red'
        };
        return _this;
    }
    RasterChannelEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, sourceChannelNames = _a.sourceChannelNames, channelSelection = _a.channelSelection, contrastEnhancementTypes = _a.contrastEnhancementTypes, locale = _a.locale;
        var rgbOrGray = this.state.rgbOrGray;
        var redChannel;
        if (channelSelection && this.isRgbChannel(channelSelection) && channelSelection.redChannel) {
            redChannel = channelSelection.redChannel;
        }
        var greenChannel;
        if (channelSelection && this.isRgbChannel(channelSelection) && channelSelection.greenChannel) {
            greenChannel = channelSelection.greenChannel;
        }
        var blueChannel;
        if (channelSelection && this.isRgbChannel(channelSelection) && channelSelection.blueChannel) {
            blueChannel = channelSelection.blueChannel;
        }
        var grayChannel;
        if (channelSelection && this.isGrayChannel(channelSelection) && channelSelection.grayChannel) {
            grayChannel = channelSelection.grayChannel;
        }
        var formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 }
        };
        return (React.createElement("div", null,
            React.createElement(antd_1.Form.Item, __assign({}, formItemLayout),
                React.createElement("span", null, locale.titleLabel)),
            React.createElement(antd_1.Form.Item, __assign({ label: locale.channelSelectionLabel }, formItemLayout),
                React.createElement(antd_1.Select, { className: "editor-field rgb-or-gray-field", allowClear: true, value: rgbOrGray, onChange: this.onSelectionChange },
                    React.createElement(Option, { key: "rgb", value: "rgb" }, locale.channelSelectionRgbLabel),
                    React.createElement(Option, { key: "gray", value: "gray" }, locale.channelSelectionGrayLabel))),
            !rgbOrGray ? null :
                (React.createElement(antd_1.Tabs, { onChange: this.onTabChange, type: "card" }, rgbOrGray === 'rgb' ? ([
                    React.createElement(TabPane, { tab: this.getTabLabel('red'), key: "red" },
                        React.createElement(ChannelField_1.default, { channel: redChannel, contrastEnhancementTypes: contrastEnhancementTypes, onChange: function (channel) {
                                _this.onChannelFieldChange('red', channel);
                            }, sourceChannelNames: sourceChannelNames })),
                    React.createElement(TabPane, { tab: this.getTabLabel('green'), key: "green" },
                        React.createElement(ChannelField_1.default, { channel: greenChannel, contrastEnhancementTypes: contrastEnhancementTypes, onChange: function (channel) {
                                _this.onChannelFieldChange('green', channel);
                            }, sourceChannelNames: sourceChannelNames })),
                    React.createElement(TabPane, { tab: this.getTabLabel('blue'), key: "blue" },
                        React.createElement(ChannelField_1.default, { channel: blueChannel, contrastEnhancementTypes: contrastEnhancementTypes, onChange: function (channel) {
                                _this.onChannelFieldChange('blue', channel);
                            }, sourceChannelNames: sourceChannelNames }))
                ]) : (React.createElement(TabPane, { tab: this.getTabLabel('gray'), key: "gray" },
                    React.createElement(ChannelField_1.default, { channel: grayChannel, contrastEnhancementTypes: contrastEnhancementTypes, onChange: function (channel) {
                            _this.onChannelFieldChange('gray', channel);
                        }, sourceChannelNames: sourceChannelNames })))))));
    };
    RasterChannelEditor.componentName = 'RasterChannelEditor';
    RasterChannelEditor.defaultProps = {
        locale: en_US_1.default.GsRasterChannelEditor
    };
    return RasterChannelEditor;
}(React.Component));
exports.RasterChannelEditor = RasterChannelEditor;
exports.default = LocaleWrapper_1.localize(RasterChannelEditor, RasterChannelEditor.componentName);
//# sourceMappingURL=RasterChannelEditor.js.map